'use client';

import React, { FC, JSX } from 'react';
import { ApiProductsCacheResponse } from '@ibe/api';
import { Props } from '@/types/cms/magnolia';
import { usePageViewEventOnCookieConsent } from '@/Hooks/usePageViewEventOnCookieConsent';

const ProductPageViewEventWrapper: FC<{
  pageProps?: Props;
  selectedProductPackage?: ApiProductsCacheResponse;
}> = ({ pageProps, selectedProductPackage }): JSX.Element => {
  const { albConfig } = pageProps || {};

  usePageViewEventOnCookieConsent(pageProps, albConfig, undefined, {
    productPackage: selectedProductPackage
  });

  return <></>;
};

export default ProductPageViewEventWrapper;
